
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitolavasacab() {



    const cardData =
    {
        keyword: ' Mumbai to Lavasa Cab     ',
        heading: 'Deva Cabs: Mumbai to Lavasa Cab ',
        headingDescription: 'Deva Cabs offers convenient and comfortable cab services from Mumbai to Lavasa, ideal for leisure trips, family outings, and romantic getaways. Located around 190 km from Mumbai, Lavasa is a scenic hill city, and our well-maintained cabs ensure a smooth drive through lush greenery and winding roads. Choose from Sedans, SUVs, or Innova Crysta for a personalized travel experience. With fixed pricing, on-time pickups, and professional drivers, Deva Cabs makes your Mumbai to Lavasa journey relaxing and memorable.',

        top: 'Top Places to Visit in Lavasa with Deva Cabs',

"topPlaces": [
  {
    "title": "Lakeside Promenade",
    "location": "Lavasa, Maharashtra",
    "description": "The Lakeside Promenade is the heart of Lavasa, offering a picturesque waterfront lined with cafes, restaurants, and boutiques. Visitors can enjoy peaceful walks, boat rides, or simply relax by the Warasgaon Lake while taking in the European-style architecture and serene ambiance."
  },
  {
    "title": "Warasgaon Lake",
    "location": "Lavasa, Maharashtra",
    "description": "Warasgaon Lake is a large and tranquil reservoir that adds to Lavasa's scenic beauty. Popular for boating and lakeside picnics, the lake is surrounded by lush green hills and offers visitors an ideal spot to unwind, photograph, or enjoy water sports during their stay."
  },
  {
    "title": "Temghar Dam",
    "location": "Near Lavasa, Maharashtra",
    "description": "Temghar Dam is a lesser-known gem near Lavasa offering panoramic views of the backwaters and hills. It’s an ideal location for photography, scenic drives, and quick stops on the way to Lavasa. The dam is especially captivating during monsoons when it's full and misty."
  },
  {
    "title": "Bamboosa",
    "location": "Lavasa, Maharashtra",
    "description": "Bamboosa is an arts and crafts center in Lavasa that promotes eco-friendly bamboo products made by local artisans. Visitors can shop for souvenirs, learn about bamboo craftsmanship, and support local employment initiatives. It’s a culturally enriching stop in the modern hill town."
  },
  {
    "title": "Xthrill Adventure Park",
    "location": "Lavasa, Maharashtra",
    "description": "Xthrill Adventure Park offers a range of outdoor activities like zip-lining, rappelling, rock climbing, and ATV rides. It’s perfect for thrill-seekers and groups looking to add a touch of adventure to their Lavasa experience amidst beautiful natural surroundings."
  },
  {
    "title": "Lavasa Nature Trail",
    "location": "Lavasa, Maharashtra",
    "description": "The Lavasa Nature Trail is a guided trekking route that lets visitors explore the rich flora, fauna, and landscapes of the surrounding Western Ghats. It’s ideal for birdwatchers, nature lovers, and anyone looking for a peaceful walk through forests and hills."
  },
  {
    "title": "Dasvino Town & Country Club",
    "location": "Lavasa, Maharashtra",
    "description": "Dasvino Club is Lavasa's premium recreational facility offering fine dining, spa services, a swimming pool, and indoor sports. Even non-members can enjoy luxury experiences here, making it a perfect stop for relaxation, wellness, and upscale leisure."
  },
  {
    "title": "Ekam – The Retreat",
    "location": "Lavasa, Maharashtra",
    "description": "Ekam is a wellness and yoga retreat in Lavasa that offers guided meditation, Ayurvedic treatments, and detox programs. Surrounded by the quiet hills, it's ideal for spiritual seekers and health-conscious visitors looking to rejuvenate mind and body."
  },
  {
    "title": "Varasgaon Backwaters Drive",
    "location": "Lavasa, Maharashtra",
    "description": "The scenic drive along Varasgaon Backwaters en route to Lavasa offers stunning vistas, dense greenery, and misty valleys. It's popular among bikers and road trip enthusiasts for sunrise rides, photo stops, and short detours into nature."
  },
  {
    "title": "Lakeshore Watersports",
    "location": "Lavasa, Maharashtra",
    "description": "Located along the Lakeside Promenade, Lakeshore Watersports offers kayaking, paddle boating, jet skiing, and more. It’s a fun and family-friendly way to enjoy the calm waters of Lavasa and make the most of your visit to this modern hill station."
  }
],



"services": [
  {
    "name": "Mumbai to Lavasa Cab",
    "description": "Planning a scenic escape to Lavasa? Deva Cabs offers trusted and comfortable Mumbai to Lavasa cab services. Enjoy a stress-free ride through the beautiful Sahyadri hills in our well-maintained vehicles driven by experienced chauffeurs. Whether for leisure, business, or a short break, our cabs ensure a smooth and scenic journey with door-to-door pickup and drop."
  },
  {
    "name": "One-way cab Mumbai to Lavasa",
    "description": "Book a reliable one-way cab from Mumbai to Lavasa with Deva Cabs for a hassle-free trip. Perfect for solo travelers, students, or families heading to Lavasa for extended stays, this service offers clean cars, no return fare, and timely pickup — all at budget-friendly prices."
  },
  {
    "name": "Lavasa taxi from Mumbai",
    "description": "Deva Cabs provides seamless taxi services to Lavasa from Mumbai, suitable for vacations, family outings, or work-from-hill stays. Choose from a wide range of vehicles, enjoy smooth highway driving, and reach Lavasa comfortably while our professional drivers handle the route."
  },
  {
    "name": "AC cab Mumbai to Lavasa",
    "description": "Beat the heat and humidity with Deva Cabs’ fully air-conditioned cabs from Mumbai to Lavasa. Our AC cabs offer a cool, calm, and enjoyable ride with plush seating, clean interiors, and polite chauffeurs for a relaxed hill station journey."
  },
  {
    "name": "SUV cab hire Mumbai to Lavasa",
    "description": "Traveling with a group or need extra luggage space? Deva Cabs offers spacious and powerful SUV cab hires from Mumbai to Lavasa. Enjoy enhanced road grip, ample legroom, and smooth suspension — ideal for long drives and curvy mountain routes."
  },
  {
    "name": "Luxury car rental Mumbai to Lavasa",
    "description": "Experience luxury on wheels with our high-end car rentals from Mumbai to Lavasa. Choose from sedans, executive cars, and luxury SUVs that feature leather interiors, top-notch comfort, and professional chauffeurs. Perfect for VIPs, business travel, or romantic getaways."
  },
  {
    "name": "Chauffeur cab Mumbai to Lavasa",
    "description": "Let our trained chauffeurs drive you safely to Lavasa while you relax and enjoy the scenic route. Our chauffeur-driven cabs from Mumbai to Lavasa ensure professionalism, courteous behavior, route familiarity, and total comfort throughout your ride."
  },
  {
    "name": "Mumbai to Lavasa sightseeing cab",
    "description": "Explore the picturesque lakes, nature trails, and viewpoints of Lavasa with Deva Cabs’ sightseeing cab services. Our drivers know the best spots and can customize the trip to include stops at attractions like Temghar Dam, Bamboosa, and Lavasa Promenade."
  },
  {
    "name": "Online cab booking Mumbai to Lavasa",
    "description": "Booking a cab to Lavasa is just a few clicks away with Deva Cabs. Use our online portal to select vehicle type, travel date, and route. Get instant confirmation, upfront pricing, and 24/7 support — all designed to make your booking experience smooth and reliable."
  },
  {
    "name": "Affordable taxi Mumbai to Lavasa",
    "description": "Travel without breaking the bank with Deva Cabs’ affordable Mumbai to Lavasa taxi services. Choose from a range of budget vehicles with competitive pricing, no hidden fees, and on-time service, ensuring great value and peace of mind."
  },
  {
    "name": "Round trip cab Mumbai to Lavasa",
    "description": "Planning to return the same day or next? Deva Cabs offers round trip packages from Mumbai to Lavasa with flexible hours and wait-time options. Enjoy a convenient and cost-effective way to travel without worrying about finding transport for your return."
  },
  {
    "name": "Premium cab to Lavasa from Mumbai",
    "description": "Looking for an elite ride? Our premium cab services from Mumbai to Lavasa feature high-end vehicles with extra legroom, smooth performance, and executive-class interiors. Ideal for CEOs, dignitaries, and travelers who value privacy and style."
  },
  {
    "name": "Family cab Mumbai to Lavasa",
    "description": "Deva Cabs provides spacious and family-friendly vehicles to Lavasa, ensuring a safe, smooth, and joyful journey for all members — from kids to elders. Our drivers are courteous and our cabs come with comfort features suited for long-distance family travel."
  },
  {
    "name": "Corporate taxi Mumbai to Lavasa",
    "description": "Deva Cabs specializes in corporate taxi services from Mumbai to Lavasa. Whether it’s for a team outing, business conference, or executive travel, our cars are punctual, clean, and suited for professional journeys with invoicing and GST-compliant billing available."
  },
  {
    "name": "Weekend cab Mumbai to Lavasa",
    "description": "Escape the city chaos and book a weekend cab from Mumbai to Lavasa with Deva Cabs. Our flexible travel slots, round trip combos, and comfortable cars make your hill station retreat easy and stress-free. Book in advance to grab weekend deals and enjoy Lavasa at your pace."
  }
],
"tableData": [
  ["Mumbai to Lavasa Cab", "-One-way cab Mumbai to Lavasa"],
  ["Lavasa taxi from Mumbai", "-AC cab Mumbai to Lavasa"],
  ["SUV cab hire Mumbai to Lavasa", "-Luxury car rental Mumbai to Lavasa"],
  ["Chauffeur cab Mumbai to Lavasa", "-Mumbai to Lavasa sightseeing cab"],
  ["Online cab booking Mumbai to Lavasa", "-Affordable taxi Mumbai to Lavasa"],
  ["Round trip cab Mumbai to Lavasa", "-Premium cab to Lavasa from Mumbai"],
  ["Family cab Mumbai to Lavasa", "-Corporate taxi Mumbai to Lavasa"],
  ["Weekend cab Mumbai to Lavasa", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Lavasa Cab Service",
    "WhyChoosedescription": "Our Mumbai to Lavasa cab service is built around punctuality, reliability, and convenience. Whether you’re traveling for a relaxing weekend, a family retreat, or a romantic getaway, we ensure that your journey starts right from your doorstep with timely pickup and a well-planned route. Count on us for a stress-free ride through the scenic Sahyadris and winding hill roads that lead to Lavasa’s picturesque landscapes."
  },
  {
    "WhyChooseheading": "Comfortable Vehicles for a Long and Scenic Journey",
    "WhyChoosedescription": "The journey from Mumbai to Lavasa takes approximately 5–6 hours, and comfort is key. Our fleet includes sedans, SUVs, and premium cars—all fully air-conditioned, spacious, and fitted with ergonomic seating. You’ll enjoy a smooth, relaxing ride with ample legroom, clean interiors, and plenty of luggage space. Whether traveling solo or with a group, we ensure you arrive at Lavasa refreshed and ready to explore."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Hill and Expressway Routes",
    "WhyChoosedescription": "Our drivers are trained for long-distance and hill station driving. They are familiar with the Mumbai–Pune Expressway, as well as the narrow, winding roads that lead up to Lavasa. With their in-depth knowledge of road conditions, rest stops, and alternate routes, you’re assured a safe, comfortable, and enjoyable journey—even through sharp curves and mountain paths."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "We provide upfront pricing that includes all tolls, driver fees, and fuel costs—so there are no surprises at the end of your ride. Our affordable and competitive rates ensure you get premium service without breaking your budget. You'll receive a complete fare breakdown before your trip begins, so you can travel with clarity and confidence."
  },
  {
    "WhyChooseheading": "24/7 Availability for Planned or Last-Minute Trips",
    "WhyChoosedescription": "Lavasa is a popular destination for both planned holidays and spontaneous escapes—and we cater to both. Our cabs are available 24/7, allowing you to book your ride at any time of day or night. Whether you need an early morning pickup or a late-night return from Lavasa, our round-the-clock availability ensures complete travel flexibility."
  },
  {
    "WhyChooseheading": "Easy Booking Process with Instant Confirmation",
    "WhyChoosedescription": "Booking your cab from Mumbai to Lavasa is quick and convenient. Our user-friendly online platform and responsive customer support team make it easy to reserve your ride in just a few minutes. You’ll receive instant booking confirmation, trip details, and driver contact info—so you’re fully prepared before your journey begins."
  },
  {
    "WhyChooseheading": "Safe and Well-Maintained Vehicles",
    "WhyChoosedescription": "Safety is our top priority, especially on hilly and long-distance routes. Our vehicles are regularly serviced, sanitized, and equipped with modern safety features like GPS tracking, seat belts, first-aid kits, and working air conditioning. Our drivers follow strict safety protocols and traffic rules to give you peace of mind throughout the ride."
  },
  {
    "WhyChooseheading": "Personalized Travel Options for All Types of Travelers",
    "WhyChoosedescription": "Whether you're traveling alone, with friends, or on a family vacation, we offer customizable travel plans to suit your needs. Need a one-way drop, round trip, or multiple stops on the way? We can tailor the journey accordingly. From choosing your vehicle type to scheduling stopovers, we make your Mumbai to Lavasa cab experience flexible, personal, and stress-free."
  }
]




    }









const faqData = [
  {
    question: "Can I book a cab from Mumbai to Lavasa with Deva Cabs?",
    answer: "Yes, Deva Cabs offers comfortable and reliable cab services from Mumbai to Lavasa for leisure, business, or family travel."
  },
  {
    question: "How long does it take to travel from Mumbai to Lavasa by cab?",
    answer: "The journey usually takes around 4 to 5 hours, depending on the traffic and weather conditions."
  },
  {
    question: "What vehicle options are available for Mumbai to Lavasa travel?",
    answer: "We offer a wide range of vehicles such as sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers for group travel."
  },
  {
    question: "Can I schedule a cab in advance from Mumbai to Lavasa?",
    answer: "Yes, you can easily pre-book your cab via our website, app, or by contacting our customer support."
  },
  {
    question: "Are one-way trips available from Mumbai to Lavasa?",
    answer: "Yes, we provide affordable one-way cab options without charging for the return journey."
  },
  {
    question: "Are tolls and parking fees included in the fare?",
    answer: "Toll and parking charges are generally additional and will be shared with full transparency at the time of booking."
  },
  {
    question: "Is the service available late at night or early in the morning?",
    answer: "Yes, our cab services are available 24/7 to suit your travel schedule."
  },
  {
    question: "Is the trip from Mumbai to Lavasa safe for solo or female travelers?",
    answer: "Absolutely. All Deva Cabs drivers are verified and trained to ensure a safe and pleasant experience for all passengers."
  },
  {
    question: "Can I book a round trip to Lavasa with return to Mumbai?",
    answer: "Yes, we offer flexible round-trip packages that allow you to return the same day or after a longer stay."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Lavasa cab service?",
    answer: "Deva Cabs offers clean vehicles, professional drivers, on-time pickups, and transparent pricing for a stress-free journey."
  }
];

const testimonialData = [
  {
    id: 33,
    name: 'Mr. Vishal Mehta',
    role: 'Family Traveler',
    review: 'Booked a cab from Mumbai to Lavasa with Deva Cabs. The ride was smooth, the vehicle was comfortable, and the driver was courteous. Great service!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 34,
    name: 'Ms. Ruchi Jain',
    role: 'Weekend Tourist',
    review: 'We planned a weekend trip to Lavasa and chose Deva Cabs. Everything from booking to the journey was perfect. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];






































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lavasa Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-lavasa-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Lavasa cab with Deva Cabs. Choose from AC, SUV, luxury, and chauffeur-driven cabs for one-way, round trip, sightseeing, family, corporate, and weekend trips. Easy online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-lavasa-cab" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Lavasa Cab | Reliable & Affordable Taxi Service | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Lavasa cab with Deva Cabs. AC, SUV, luxury, and chauffeur-driven cabs available for one-way, round trip, sightseeing, family, corporate, and weekend trips. Easy online booking." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Lavasa Cab, One-way cab Mumbai to Lavasa, Lavasa taxi from Mumbai, AC cab Mumbai to Lavasa, SUV cab hire Mumbai to Lavasa, Luxury car rental Mumbai to Lavasa, Chauffeur cab Mumbai to Lavasa, Mumbai to Lavasa sightseeing cab, Online cab booking Mumbai to Lavasa, Affordable taxi Mumbai to Lavasa, Round trip cab Mumbai to Lavasa, Premium cab to Lavasa from Mumbai, Family cab Mumbai to Lavasa, Corporate taxi Mumbai to Lavasa, Weekend cab Mumbai to Lavasa" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitolavasacab;